export function ConvertEmmettSportIDToBetRadarID(emmetID) {
  switch (emmetID) {
    case -10:
      return -10; //svi sportovi
    case 1:
      return -1; //unknown
    case 2:
      return 1; //soccer
    case 3:
      return 2; //basketball
    case 4:
      return 3; //baseball
    case 5:
      return 4; //ice hoceky
    case 6:
      return 5; //tennis
    case 7:
      return 6; //handball
    case 8:
      return 7; //floorball
    case 9:
      return 9; //golf
    case 10:
      return 11; //motorsport
    case 11:
      return 12; //rugby
    case 12:
      return 13; //aussie rules
    case 13:
      return 14; //winter sports
    case 14:
      return 15; //bandy
    case 15:
      return 16; //american football
    case 16:
      return 17; //cycling
    case 17:
      return 19; //snoooker
    case 18:
      return 20; //table tennis
    case 19:
      return 22; //darts
    case 20:
      return 23; //volleyball
    case 21:
      return 26; //waterpolo
    case 22:
      return 28; //curling
    case 23:
      return 29; //futsal
    case 24:
      return 31; //badminton
    case 25:
      return 34; //beach volley
    case 26:
      return 60; //beach soccer
    case 27:
      return 61; //pesapallo
    case 28:
      return 21; //cricket
    case 29:
      return 24; //field hockey
    case 30:
      return 32; //bowls
    case 31:
      return 10; //boxing
    case 32:
      return 108; //world lottery
    case 33:
      return 106; //soccer mythical
    case 34:
      return 37; //squash
    case 35:
      return 110; //LoL
    case 36:
      return 117; //MMA
    case 37:
      return 30; //olympics
    case 38:
      return 18; //specials
    case 39:
      return 0; //loto
    case 40:
      return 81; //sailing
    case 41:
      return 36; //athletics
    case 42:
      return 127; //street fighter v
    case 43:
      return 43; //alpine skiings
    case 44:
      return 48; //ski jumping
    case 45:
      return 47; //nordic combined
    case 46:
      return 46; //cross country
    case 47:
      return 25; //pool
    case 48:
      return 103; //freestyle skiing
    case 49:
      return 50; //speed skating
    case 50:
      return 49; //snowboard
    case 51:
      return 105; //short track
    case 52:
      return 104; //skeleton
    case 53:
      return 102; //figure skating
    case 54:
      return 45; //bobsleigh
    case 55:
      return 51; //luge
    case 56:
      return 142; //formula e
    case 57:
      return 55; //horse racing
    case 58:
      return 38; //rink hockey
    case 59:
      return 155; //basketball 3x3
    case 60:
      return 138; //kabaddi
    default:
      return -1; //default unknown
  }
}



// WEBPACK FOOTER //
// ./src/HOCs/Helpers/SportConverter.js